module.exports = __webpack_public_path__ + "assets/creditcard-b59418.svg";